/// <summary>
/// This object provides js functions for the PipelineUnitList visual <br/>
/// <br/>
/// Author: AFU<br />
/// Date: 20.1.2026<br />
/// Copyright ©: EUDT GmbH 2026 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 20.1.2026                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.PipelineUnitList", jQuery.common.vcBaseV4, {
    myData: {
        versions: null,
        list: null,
        agents: null
    },
    myStatus: {
        version: "",
        units: {}
    },

    _create: function () {
        this._createVisual(400);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
            me._setRoot(".pipeline-unitlist");
            me._buildHtml();
            me._setHeightsAndWidths();
        } catch (e) { me._writeErr(e); return false;} 
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {
          
            if (me.specific.tokenValidUntil == "") {
                me.showMessage("No expiration date for the devops pipeline access token was set! Please check the key store for according entries!", true);
                return true;
            }
            me._initStructure();
            me._fetch();
           
        } catch (e) { me._writeErr(e);return false; }
        return true;
    },

    _buildHtml: function () {
        /// <summary>
        /// This function builds the html structure only
        /// </summary>
        var me = this;
        try {
            me.myHtml = {
                menu: {}, content: { versions: {}, list: {} } };


            let obj = me.myHtml.menu;
            obj.wrapper = me._setObj("", "vc-grid-margin-bottom").css("width", "100%").css("height", "80px");
            obj.reload = me._setMainButton("reload", me.specific.resources.iconReload, me.specific.resources.reload).addClass("active");
            obj.tokenExpires = me._setObj("", "vc-grid-margin-left vc-grid-5col icon-color-error float ").hide();
            obj.update = me._setMainButton("btn-update", "<i class='fa fa-cloud-upload-alt'></i>", "update").css("float", "right");    
            obj.wrapper.append(obj.reload,obj.tokenExpires, obj.update);

            obj = me.myHtml.content;
            obj.wrapper = me._setObj("", "").css("width", "100%");
            me.myRoot.append(me.myHtml.menu.wrapper,  me.myHtml.content.wrapper);

            obj = me.myHtml.content.versions;
            obj.wrapper = me._setObj("", "vc-list vc-grid-2col float vc-grid-margin-right float-box");
            obj.header = me._setListHeader("");
            // generate header list
            var line = me._setListItem();
            line.column.append(me._setListElement("", "").html("Version"));
            obj.header.append(line.item);
            obj.entries = me._setObj("entries", "vc-list-table").css("border", "1px solid #ddd");
            obj.wrapper.append(obj.header, obj.entries);

            me.myHtml.content.wrapper.append(obj.wrapper);

            obj = me.myHtml.content.list;
            obj.wrapper = me._setObj("", "vc-list  float-box");
            obj.filter = me._setObj("filter", "vc-filter vc-grid-2col vc-grid-margin-bottom float-box");
            me.myHtml.content.list.wrapper.append(obj.filter);


            obj.header = me._setListHeader("");
            // generate header list
            var line = me._setListItem();
            line.column.append(me._setListElement("", "w3").html("<br/>"));
            line.column.append(me._setListElement("", "w10").html("Unit"));
            line.column.append(me._setListElement("", "w15").html("Status"));
            line.column.append(me._setListElement("", "w15").html("Update-Agent"));
            line.column.append(me._setListElement("", "w10").html("Deployed Version"));
            line.column.append(me._setListElement("", "w25").html("Installed Version"));
            line.column.append(me._setListElement("", "w20").html("Log"));

            obj.header.append(line.item);

            obj.entries = me._setObj("entries", "vc-list-table").css("max-height", "none").css("border", "1px solid #ddd");
            obj.wrapper.append(obj.header, obj.entries);

            me.myHtml.content.wrapper.append(obj.wrapper);

        } catch (e) {me._writeErr(e);return false;}
        return true;
    },

    _initStructure: function () {
        /// <summary>
        /// This function inits various events and handlers
        /// </summary>
        var me = this;
        try {

            //first, we write a note if the devops PAT will expire soon
            var now = moment();
            var tokenUntil = moment(me.specific.tokenValidUntil, "DD.MM.YYYY");
            var daysRemaining = tokenUntil.diff(now, 'days');
            if (daysRemaining <= 90) me.myHtml.menu.tokenExpires.html("The devops pipeline access token will expire in " + daysRemaining +" days! Please renew it in time!").show();
           
          

            me.myHtml.content.list.filter.vcFilter({ callback: function () { me._filter(); } });

            //init reload button
            me.myHtml.menu.reload.off("click").on("click", function () { me._fetch(); });
            //init upload button
            me.myHtml.menu.update.off("click").on("click", function () { me._update(); });

            //clickhandler for version list
            me.myHtml.content.versions.entries.off("click", ".vc-list-item").on("click", ".vc-list-item", function () {
                var obj = $(this);
                if (!obj.hasClass("building")) {
                    me.myHtml.content.versions.entries.find(".vc-list-item").removeClass("selected");
                    obj.addClass("selected");
                    me.myStatus.version = obj.data("name");
                    me._validateUpdateState();
                }
            });

            //clickhandler for unit list
            me.myHtml.content.list.entries.off("click", ".chb-select").on("click", ".chb-select", function () {
                me.myStatus.units = [];
                me.myHtml.content.list.entries.find(".chb-select:checked").each(function () {
                    me.myStatus.units.push($(this).data("Id"));
                });
                me._validateUpdateState();
            });

        } catch (e) { me._writeErr(e); }
    },

    _fetch: function () {
        /// <summary>
        /// This function fetches the versions and the list
        /// </summary>
        var me = this;
        try {
            me._fetchVersions();
            me._fetchList();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _fetchVersions: function () {
        /// <summary>
        /// This function fetches the versions for the left column
        /// </summary>
        var me = this;
        try {
            me._setLoadingIcon(me.myHtml.content.versions.entries);

            me.getData({ TypeId: 1 }, function (result) {
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true); return true;
                }
                me.myData.versions = result;
                me._generateVersionList();
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _generateVersionList: function () {
        /// <summary>
        /// This function generates the table and fills the list with data
        /// </summary>
        var me = this;
        try {
            
            if (me.myData.versions === null || me.myData.versions.length == 0) {
                me.myHtml.content.versions.entries.html($("<br>")).append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }
          
            //clear list
            me.myHtml.content.versions.entries.html("");
          
            // fill entry list
            for (i = 0; i < me.myData.versions.length; i++) {
                me._fillVersionRow(me.myData.versions[i]);
            };
           
            me._setAltListStyle(me.myHtml.content.versions.entries);
            return true;

        } catch (e) {
            me._writeErr(e);
            return false;
        }
    },

    _fillVersionRow: function (row) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        var me = this;
        try {

            var line = me._setListItem();
            line.item.addClass("found").data("name", row.Name);
            
            if (row.Status == 0) {
                line.item.addClass("building").addClass("icon-color-error").css("opacity", "0.4");
            }
            var html = $("<div>");//.addClass("vc-grid-2col");
            html.append("<b>" + row.Name + "</b> ");
            if (row.Status == 0) {
                html.append($("<span>").html(" - in progress ... "));
            }

            var sub = $("<div>").css("font-size", "smaller");
            sub.append(row.Timestamp + " (" + row.User + ")");
            html.append(sub);
            line.column.append(me._setListElement("", "").html(html));
          
            me.myHtml.content.versions.entries.append(line.item);

            return true;
        } catch (e) { me._writeErr(e); return false; }
    },

    _fetchList: function () {
        /// <summary>
        /// This function fetches the data based on the current settings
        /// </summary>
        var me = this;
        try {
            me._setLoadingIcon(me.myHtml.content.list.entries);

            me.getData({ TypeId: 2 }, function (result) {
                
                //check response content
                if (result == null) {  me.showMessage(me.resources.err_loadData, true); return true; }
                me.myData.list = result;

                //now, we need all active agents before we build our list
                me._fetchActiveAgents();
            });
        } catch (e) { me._writeErr(e); return false; } return true;
    },

    _fetchActiveAgents: function () {
        /// <summary>
        /// This function fetches all active pipeline agents
        /// </summary>
        var me = this;
        try {

            me.getData({ TypeId: 3 }, function (result) {
                if (result == null) { me.showMessage(me.resources.err_loadData, true); return true;}

                if (result.Exception == null) {
                    me.myData.agents = result.Exception == null ? result.Result : null;
                }
                //console.info(me.myData.agents);
                me._generateList();
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _generateList: function () {
        /// <summary>
        /// This function generates the table and fills the list with data
        /// </summary>
        var me = this;
        try {

             if (me.myData.list === null || me.myData.list.length == 0) {
                me.myHtml.content.list.entries.html($("<br>")).append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }
            //clear list
            me.myHtml.content.list.entries.html("");
           
            // fill entry list
            for (i = 0; i < me.myData.list.length; i++) {
                me._fillRow(me.myData.list[i]);
            };

            me._filter();

            me._setAltListStyle(me.myHtml.content.list.entries);
            return true;

        } catch (e) {
            me._writeErr(e);
            return false;
        }
    },

    _fillRow: function (row) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        var me = this;
        try {


            var line = me._setListItem();

            if (row.DeployStatus > 1 && row.DeployStatus < 5) {
                line.item.css("font-weight", "bold");
            }
            var agent = "no agent installed";
            var foundAgent = me.myData.agents.find(a => a.Name === row.AgentName);
            var agentVersion = foundAgent ? "(V" + foundAgent.Version + ")<br/><span style='font-size:x-small'>" + foundAgent.OsDescription + "</span>" : "";
            if (row.AgentName.length > 0) {
                agent = row.AgentName;
                agent = (foundAgent ? "<i class='fa fa-circle' style='color:green'  title='agent online'> </i>  " : "<i class='fa fa-circle' style='color:red' title='agent offline'> </i>") + " " + agent + (foundAgent ? (" " + agentVersion)  : "") ;
               
            }
          

            if (row.AgentActive && (row.DeployStatus == 0 || row.DeployStatus == 5) && foundAgent) {
                let chkSelect = me._setInput("", "chb-select").attr("type", "checkbox").prop("name", "chb-select").data("Id", row.Id);
                line.column.append(me._setListElement("select", "w3").css("text-align", "center").html(chkSelect).append($("<br>")));
            } else { 
                if (!row.AgentActive) {
                    line.item.addClass("noagent").css("opacity", "0.4");
                }
                line.column.append(me._setListElement("", "w3").html("<br/>"));
            }

            var name = row.Name;
            if (row.AgentInfo != "") {
                name += "<br/><span style='font-size:smaller'>" + row.AgentInfo + "</span>"
            }
            line.column.append(me._setListElement("", "w10").html(name));
            var status = "-";
            switch (row.DeployStatus) {
                case 0: status = "-"; break;
                case 1: status = "waiting for deployment ..."; break;
                case 2: status = "deploying ..."; break;
                case 3: status = "installing ..."; break;
                case 5: status = "<span style='color:red'>error occured on deploy!</span>"; break;
                default:
            }
            if (row.DeployStatus > 0) {
                status = status + "<br/><span style='font-size:smaller'>" + row.DeployTimestamp + " h - " +  row.InstallingVersion + ", " + row.DeployUser + "</span>";
            }
            line.column.append(me._setListElement("", "w15").html(status));
            //line.column.append(me._setListElement("", "w15").html(row.InstallingVersion.length > 0 ? row.InstallingVersion : "-"));
           
            line.column.append(me._setListElement("", "w15").html(agent));
            line.column.append(me._setListElement("", "w10").html(row.DeployVersion.length > 0 ? row.DeployVersion : "-"));

            var captVersion = row.CaptureVersion;
            if (row.CaptureTimestamp != "") {
                captVersion += "<br/><span style='font-size:smaller'>" + row.CaptureTimestamp + " h</span>"
            }
            line.column.append(me._setListElement("", "w25").html(captVersion));
            line.column.append(me._setListElement("", "w20").css("font-size", "smaller").html(row.DeployLog.length > 0 ? row.DeployLog  : "-"));
            //line.column.append(me._setListElement("", "w5").html("TODO: edit btn"));
            me.myHtml.content.list.entries.append(line.item);

            return true;
        } catch (e) { me._writeErr(e); return false; }
    },

    _validateUpdateState: function () {
        /// <summary>
        /// This function validates wether the update button should be active
        /// </summary>
        var me = this;
        try {
            me.myHtml.menu.update.removeClass("active");
            if (me.myStatus.version != "" && me.myStatus.units.length > 0) {
                me.myHtml.menu.update.addClass("active");
            }

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _update: function () {
        /// <summary>
        /// This function send the update command
        /// </summary>
        var me = this;
        try {
            if (!me.myHtml.menu.update.hasClass("active")) return false;

            me.myHtml.menu.update.removeClass("active");
            //var param = { TypeId: 1 };

            me.updateData(me.myStatus, function (result) {
                if (result == null) {
                    me.showMessage(me.resources.err_saveData, true); return true;
                }
                me._fetch();

            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _filter: function () {
        this._doListTableFilter(this.myHtml.content.list.entries);
    },

    _setHeightsAndWidths: function () {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            let hList = me._getVisualHeight() - me.myHtml.menu.wrapper.outerHeight() - 25;
          
            me.myHtml.content.wrapper.css("height", hList);
            me.myHtml.content.list.wrapper.css("height", hList);
            me.myHtml.content.versions.wrapper.css("height", hList);
            me.myHtml.content.list.entries.css("height", hList - 85);
            me.myHtml.content.versions.entries.css("height", hList - 37);
            me.myHtml.content.list.wrapper.css("width", me._getVisualWidth() - me.myHtml.content.versions.wrapper.outerWidth() - 20);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    specificInfoHandling: function (bError) {
        /// <summary>
        /// This function handles error states - it hides specific objects on error message
        /// </summary>
        var me = this;
        try {
            if (bError) {
                me.myHtml.menu.wrapper.hide();
                me.myHtml.content.wrapper.hide();
            }
           
        } catch (e) { me._writeErr(e); return false;}
        return true;
    }
});